// @flow
import * as React from 'react'
import * as topojson from 'topojson-client'
import config from 'config'
import type { GeojsonFeature } from 'components/map/component'

type MapProps = {
  canHover: boolean,
  canTouch: boolean,
  geometryCollection: { type: string, geometries: Array<GeojsonFeature> },
  mapId: string,
  mouseOverHandler: (id: number, event: SyntheticEvent<SVGPathElement>) => void,
  pathGenerator: GeojsonFeature => string
}

/**
 * Draw a choropleth map
 * @param {object} props
 * @param props.gemeinden
 * @param props.mouseOverHandler
 * @constructor
 */
export function EventListenerMap ({
  canHover,
  canTouch,
  geometryCollection,
  mapId = '',
  mouseOverHandler,
  pathGenerator
}: MapProps): React.Element<'g'> | null {
  const gemeindeFeatures: Array<GeojsonFeature> = topojson.feature(
    config.schweiz,
    geometryCollection
  ).features

  function drawSwissMunicipalities (
    attachMouseHandler: boolean,
    areas: Array<GeojsonFeature>,
    areaIdProperty = 'GMDNR',
    idGenerator = property => property
  ): Array<React.Element<'path' | 'g'>> {
    return areas.map((feature: GeojsonFeature, index: number) => {
      const municipalityId = idGenerator(+feature.properties[areaIdProperty])

      let boundMouseOverHandler = event =>
        mouseOverHandler(+municipalityId, event)
      let interactionHandlers = {
        onMouseOver: canHover ? boundMouseOverHandler : undefined,
        onTouchStart: canTouch ? boundMouseOverHandler : undefined
      }

      return (
        <path
          key={municipalityId}
          d={pathGenerator(feature)}
          id={`${mapId}-gemeinde-${municipalityId}`}
          {...interactionHandlers}
          className='gemeinde'
          fill='transparent'
        />
      )
    })
  }

  const municipalityPaths = drawSwissMunicipalities(true, gemeindeFeatures)

  return <g className='event listening municipalities'>{municipalityPaths}</g>
}



// WEBPACK FOOTER //
// ./src/components/eventListenerMap/eventListenerMapComponent.js